import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

@Feature()
export class AlignDistributeVerticallyFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public shouldDisabled() {
        if (this.getAppService().viewableServiceLayer.selectionService.selectedElements.selectedArray!.length <= 2) {
            return true;
        }
        return false;
    }
}
